import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, tap } from 'rxjs/operators';
import { WebSocketService } from '../../../../client/app/server-communication/services/websocket.service';
import { WebSocketMessageType } from '../../../../model/web-socket-message';
import DockingActions from './docking.action-types';
import { initialDockingState } from './docking.reducers';

@Injectable()
export class DockingEffects {
    constructor(private readonly actions$: Actions, private readonly webSocketService: WebSocketService) {}

    // Docking Context
    requestDockingContext$ = createEffect(() =>
        this.actions$.pipe(
            ofType(DockingActions.requestDockingContext),
            map(action => action.locationContext),
            tap(locationContext =>
                this.webSocketService.sendMessage(WebSocketMessageType.Docking, { locationContext })
            ),
            map(() => DockingActions.loadDockingContext(initialDockingState))
        )
    );

    triggerDockingCommand$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(DockingActions.triggerDockingCommand),
                tap(action => {
                    this.webSocketService.sendMessage(WebSocketMessageType.Command, {
                        locationContext: action.commandContext.locationContext,
                        command: action.commandContext.command,
                        operator: action.operator,
                        dockingInfo: action.commandContext.dockingInfo
                    });
                })
            ),
        { dispatch: false }
    );
}
